import { useContext } from 'react';

import { resolveTranslation } from '../constants';
import { TranslationContext } from '../contexts';

export const useTranslation = () => {

  const translations = useContext(TranslationContext);

  const translate = (key: string): string => {
    return resolveTranslation(translations, key);
  };
  
  return translate;
};
